import { render } from "./roadTransport.vue?vue&type=template&id=5d23ffa3&scoped=true"
import script from "./roadTransport.vue?vue&type=script&lang=js"
export * from "./roadTransport.vue?vue&type=script&lang=js"

import "./roadTransport.vue?vue&type=style&index=0&id=5d23ffa3&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.5.21_webpack@5.101.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d23ffa3"]])

export default __exports__